export default __webpack_public_path__ + "static/media/user_activity_48_1.101a5741.svg";